module.exports = {
      id: "newsletter-usage",
      viewBox: "0 0 26 23.012",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#newsletter",
      toString: function () {
        return this.url;
      }
    }